<template>
  <div class="layout">
    <!--左侧-->
    <slot name="pageLeft"></slot>
    <!--左侧 end-->

    <!--总统计区-->
    <div class="pageTab">
      <slot name="pageTab"></slot>
    </div>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <div class="pageSearch" v-if="$slots.pageSearch && $slots.pageSearch.length">
      <slot name="pageSearch"></slot>
    </div>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <div class="pageContent">
      <slot name="pageContent"></slot>
    </div>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <div class="pageBlock" v-if="$slots.pageBlock && $slots.pageBlock.length">
      <slot name="pageBlock"></slot>
    </div>
    <!--弹窗组件区 end-->

    <!--开发器-->
    <QHdev ref="QHdev"></QHdev>
  </div>
</template>

<script>
import updatePassword from "./block/updatePassword";
import detailed from "./block/detailed";
export default {
  components: {
    updatePassword,
    detailed,
  },
  data() {
    return {
      code: "",
      user: this.$U,
    };
  },
  mounted() {
    // this.tabEqFun(this.$getCityFuqin("code"), this.$getCityFuqin("level"), this.$getCityFuqin("name"));
  },
  methods: {
   
  },
};
</script>
